import deviceIcon from '../icons/device.png';
import traylerIcon from '../icons/trayler.png';
import horseIcon from '../icons/horse.png';
import horseBlackIcon from '../icons/horse-dark.png';
import deviceBlackIcon from '../icons/device-dark.png';
import traylerBlackIcon from '../icons/trayler-dark.png';
import { PieChartOutlined } from '@ant-design/icons';


export const Icons = {
  device: deviceIcon,
  trayler: traylerIcon,
  horse: horseIcon,
  horseBlack: horseBlackIcon,
  deviceBlack: deviceBlackIcon,
  traylerBlack: traylerBlackIcon,
  PieChartOutlined: PieChartOutlined
};